module.exports = __webpack_public_path__ + "img/rns.73e68ae2.svg";